module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSpinner),
      expression: "loadingSpinner"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "Подождите"
    }
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.places != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по площадкам\n")]) : (_vm.place == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "placenotfound-text"
  }, [_vm._v("Площадка не найдена")])]) : _c('div', {
    staticClass: "place"
  }, [_c('div', {
    staticClass: "place-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.place.val.images[0]) + ')'
    }),
    attrs: {
      "id": "placeimage1"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button-over",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit back-button-over-center",
    on: {
      "click": function($event) {
        _vm.$refs.uploadingFileRef1.click()
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "uploadingFileRef1",
    staticClass: "input_file_hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadingFileOnChange(1)
      }
    }
  })]), _vm._v(" "), _c('DIV', {
    staticClass: "place-props-block"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop-title"
  }, [_vm._v("Название")]), _vm._v(" "), _c('Input', {
    staticClass: "place-prop",
    attrs: {
      "placeholder": "Название",
      "size": "large"
    },
    model: {
      value: (_vm.place.val.name),
      callback: function($$v) {
        _vm.place.val.name = $$v
      },
      expression: "place.val.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop-title"
  }, [_vm._v("Город")]), _vm._v(" "), _c('Input', {
    staticClass: "place-prop",
    attrs: {
      "placeholder": "Город",
      "size": "large"
    },
    model: {
      value: (_vm.place.val.city),
      callback: function($$v) {
        _vm.place.val.city = $$v
      },
      expression: "place.val.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop-title"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('Input', {
    staticClass: "place-prop",
    attrs: {
      "placeholder": "Адрес",
      "size": "large"
    },
    model: {
      value: (_vm.place.val.address),
      callback: function($$v) {
        _vm.place.val.address = $$v
      },
      expression: "place.val.address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop-title"
  }, [_vm._v("Описание")]), _vm._v(" "), _c('Input', {
    staticClass: "place-prop",
    attrs: {
      "placeholder": "Описание",
      "size": "large",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.place.val.description),
      callback: function($$v) {
        _vm.place.val.description = $$v
      },
      expression: "place.val.description"
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "button button-primary",
    staticStyle: {
      "width": "calc((100% - 10px - 4px) / 2)",
      "margin": "20px 0 0 0"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.saveAndClose()
      }
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "calc((100% - 10px - 4px) / 2)",
      "margin": "20px 0 0 10px"
    },
    attrs: {
      "type": "ghost",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Отменить")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4677cc8a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaceEdit.vue
// module id = 355
// module chunks = 0